import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeAnalytics, trackPageView } from '@/lib/analytics';
import { useCookieConsent } from '@/hooks/useCookieConsent';

/**
 * Hook to initialize analytics and track page views
 * Respects cookie consent preferences
 */
export function useAnalytics() {
  const location = useLocation();
  const { hasConsent } = useCookieConsent();

  // Initialize analytics when consent is given
  useEffect(() => {
    if (hasConsent('analytics')) {
      initializeAnalytics();
    }
  }, [hasConsent]);

  // Track page views on route change
  useEffect(() => {
    if (hasConsent('analytics')) {
      trackPageView(location.pathname);
    }
  }, [location.pathname, hasConsent]);
}
